import { render, staticRenderFns } from "./labelPriceRequestTypeBadge.vue?vue&type=template&id=27562e96&"
import script from "./labelPriceRequestTypeBadge.vue?vue&type=script&lang=js&"
export * from "./labelPriceRequestTypeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports